import EllipsisText from '@/components/EllipsisText';
import { Certificate } from '@carbon/icons-react';

type IProps = {
  reportDate?: string | Date | null;
  isAnnual?: boolean | null;
};

export default function ReportDateBadge({ reportDate, isAnnual }: IProps) {
  if (!reportDate) return null;
  return (
    <div className="date-badge">
      <Certificate />
      <EllipsisText label={isAnnual ? 'funds.report.annual' : 'funds.report.semi_annual'} />
    </div>
  );
}
